function Error({ statusCode }: { statusCode: number }) {
  return (
    <p>
      {statusCode ? `Erro no servidor: ${statusCode}` : "Erro desconhecido"}
    </p>
  );
}

export default Error;
